import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerAutorizacionOrden = styled(motion.div)`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 30px;
  align-items: center;

  img {
    width: 150px;
    height: 200px;
    object-fit: contain;
  }

  .container-btn {
    display: flex;
    gap: 20px;
  }

  button {
    width: 200px;
    height: 53px;
    border-radius: 8px;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    color: var(--color-white);
  }
  span {
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
  }
  .btn-container {
    display: flex;
  }

  .btn-container {
    display: flex;
    gap: 30px;
    button {
      width: 140px;
      height: 53px;
      border-radius: 8px;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      color: var(--color-white);
    }
  }
`;
